import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "login",
  "description": "turbo login 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Remote Cache 제공자에 로그인합니다."
  }, {
    "heading": "",
    "content": "기본 제공자는 Vercel입니다. 다른 제공자를 지정하려면 --api 옵션을 사용하세요."
  }, {
    "heading": "--api-url",
    "content": "Remote Cache 제공자의 API URL을 설정합니다."
  }, {
    "heading": "--login-url",
    "content": "토큰을 동적으로 생성해야 하는 로그인 요청의 URL을 설정합니다."
  }, {
    "heading": "--sso-team-team",
    "content": "팀 슬러그를 제공하여 SSO가 활성화된 팀에 연결합니다."
  }, {
    "heading": "--manual",
    "content": "로그인 서비스에서 토큰을 요청하는 대신 수동으로 토큰을 입력합니다."
  }],
  "headings": [{
    "id": "플래그-옵션",
    "content": "플래그 옵션"
  }, {
    "id": "--api-url",
    "content": "--api <url>"
  }, {
    "id": "--login-url",
    "content": "--login <url>"
  }, {
    "id": "--sso-team-team",
    "content": "--sso-team <team>"
  }, {
    "id": "--manual",
    "content": "--manual"
  }]
};
export const toc = [{
  depth: 2,
  url: "#플래그-옵션",
  title: _jsx(_Fragment, {
    children: "플래그 옵션"
  })
}, {
  depth: 3,
  url: "#--api-url",
  title: _jsx(_Fragment, {
    children: "--api <url>"
  })
}, {
  depth: 3,
  url: "#--login-url",
  title: _jsx(_Fragment, {
    children: "--login <url>"
  })
}, {
  depth: 3,
  url: "#--sso-team-team",
  title: _jsx(_Fragment, {
    children: "--sso-team <team>"
  })
}, {
  depth: 3,
  url: "#--manual",
  title: _jsx(_Fragment, {
    children: "--manual"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Remote Cache 제공자에 로그인합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본 제공자는 ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "입니다. 다른 제공자를 지정하려면 ", _jsx(_components.code, {
        children: "--api"
      }), " 옵션을 사용하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "플래그-옵션",
      children: "플래그 옵션"
    }), "\n", _jsx(_components.h3, {
      id: "--api-url",
      children: "--api <url>"
    }), "\n", _jsx(_components.p, {
      children: "Remote Cache 제공자의 API URL을 설정합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --api=https://acme.com/api"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--login-url",
      children: "--login <url>"
    }), "\n", _jsx(_components.p, {
      children: "토큰을 동적으로 생성해야 하는 로그인 요청의 URL을 설정합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --login=https://acme.com"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--sso-team-team",
      children: "--sso-team <team>"
    }), "\n", _jsx(_components.p, {
      children: "팀 슬러그를 제공하여 SSO가 활성화된 팀에 연결합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --sso-team=slug-for-team"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--manual",
      children: "--manual"
    }), "\n", _jsx(_components.p, {
      children: "로그인 서비스에서 토큰을 요청하는 대신 수동으로 토큰을 입력합니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
